import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Please DO NOT import Functional Modules separately here.
 * If you want to add/enable new modules to the list make changes 
 * to all-functional-modules.ts
 */
import { ListOfFunctionalModules } from './all-functional-modules'

@NgModule({
  imports: [
    CommonModule,
    ...ListOfFunctionalModules
  ],
  exports: [...ListOfFunctionalModules],
  declarations: []
})
export class FunctionalModule { }
